export const formatter = ({ motive, contactMe } = {}) => ({
  reason: motive,
  contact_check: contactMe,
});
